export default "/themes/nutristopa/assets/img/euthropication.png";